import { render } from "./AssetsPage.vue?vue&type=template&id=c1ba664a&ts=true"
import script from "./AssetsPage.vue?vue&type=script&lang=ts"
export * from "./AssetsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__